import { Component, OnInit, Output, ViewChild, EventEmitter, Input } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { SectoresProductivosService } from 'src/app/services/sectores-productivos.service';

import {MatSort} from '@angular/material/sort';

@Component({
  selector: 'app-estandares-marca',
  templateUrl: './estandaresMarca.component.html',
  styleUrls: ['./estandaresMarca.component.css']
})
export class EstandaresMarcaComponent implements OnInit {

 
  sectGenerales: any;
  subsectores: any;
  displayedCol: string[] = ['codigo', 'nivel', 'titulo','comite', 'secProductivo'];
  listado:any;
  listadoEm:any;
  dataSource2:MatTableDataSource<any>;
 


  @Output()
  sectorEsById = new EventEmitter<any>();

  @Output()
  backTo = new EventEmitter<any>();

  @Input() idSector:number;
  @Input() title: string;
  @Input() padre: number;
  @Input() tablaEstandar: boolean;
  @Input() marca: boolean;
  

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;

  constructor(private service: SectoresProductivosService) {
      this.idSector = 0;
      this.padre = 0;
      this.dataSource2 = new MatTableDataSource();
   }

  ngOnInit(): void {
    this.getEstandaresMarca();
  }

  /*async getEstandaresMarca(){
    let get2: any;
    try {
    get2 = await this.service.getEstandaresMarca();
    this.listadoEm=get2;
    this.dataSource2 = new MatTableDataSource<any>(this.listadoEm)
    this.dataSource2.paginator = this.paginator;
    this.dataSource2.sort = this.sort;
    
  } catch (error) {
    console.log(error);
  }
  }*/

  getEstandaresMarca(){
    this.service.getEstandaresMarca().subscribe((resp) =>{
      this.dataSource2 = new MatTableDataSource(resp);
      this.dataSource2.paginator = this.paginator;
      this.dataSource2.sort = this.sort;
    });
  }


  sectorByID(element) {
    let json = {
      element: element,
      padre: element.codigo,
      titlePadre: element.titulo,

    }

    this.sectorEsById.emit(json);
  
  }

  applyFilter2(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource2.filter = filterValue.trim().toLowerCase();
  }

  sectorByIDM(element) {
    let json = {
      element: element,
      marca:1
    }
    this.title="1";

    this.sectorEsById.emit(json);
  
  }
  back(){
    this.backTo.emit(0);
 
  }
  home(){
    window.location.reload();
  }



}
